import { convertToDisplayDateFormatddmmmyyyy } from '../../../utils/dateformatter';
import { api } from '../../../config';
import {
  formatSelectedOriginLocations,
  getCapableOriginNamesFromFobLocations,
  getFobLocationNames,
  resolveCapableLocationSelections,
  resolveFobPortLabel,
} from '../../../shared/offer-domain/delivery';

const pickDetailValue = (details, ...keys) => {
  for (const key of keys) {
    const value = details?.[key];
    if (value !== null && value !== undefined && value !== '') {
      return value;
    }
  }
  return null;
};

export const getListData = item => item?.listData || item?.ListData || [];

export const mapDeliveryDetailRow = (parentItem, details) => {
  const incotermFOBLocations = Array.isArray(details?.incotermFOBLocations)
    ? details.incotermFOBLocations
    : details?.incotermFOBLocations
      ? [details.incotermFOBLocations]
      : [];
  const listIsCapable = Array.isArray(details?.listIsCapable)
    ? details.listIsCapable
    : Array.isArray(details?.ListIsCapable)
      ? details.ListIsCapable
      : [];
  const route = details?.route ?? null;
  const fobLocationNames = getFobLocationNames({ incotermFOBLocations });
  const selectedCapableLocations = resolveCapableLocationSelections({
    incotermFOBLocations,
    listIsCapable,
  });
  const selectedCapableNames =
    getCapableOriginNamesFromFobLocations(incotermFOBLocations).length > 0
      ? getCapableOriginNamesFromFobLocations(incotermFOBLocations)
      : selectedCapableLocations.map(loc => loc.name).filter(Boolean);
  const fobPort1 =
    formatSelectedOriginLocations(selectedCapableNames) ||
    resolveFobPortLabel({ incotermFOBLocations }, route);

  return {
    id: parentItem.id,
    quantityInformationDetailId: details?.id ?? null,
    quantityInformationId: details?.quantityInformationId ?? null,
    quantityIncotermId: details?.quantityIncotermId ?? null,
    deliveryBasis: details?.deliveryBasis ?? null,
    incoterm: details?.incoterm ?? null,
    route,
    loadingPort: details?.loadingPort || fobPort1 || null,
    listIsCapable,
    incotermFOBLocations,
    fobLocationNames,
    capableLocationIds: selectedCapableLocations.map(loc => loc.id),
    selectedCapableLocations,
    selectedCapableLocation: selectedCapableLocations[0] || null,
    parcelSize:
      pickDetailValue(
        details,
        'parcelSize',
        'ParcelSize',
        'deliveryBasis',
        'DeliveryBasis'
      ) ?? null,
    port1: details?.port1 ?? null,
    addAld: details?.addAld ?? null,
    parcelSize2: pickDetailValue(details, 'parcelSize2', 'ParcelSize2'),
    port2: details?.port2 ?? null,
    addAld2: details?.addAld2 ?? null,
    parcelSize3: pickDetailValue(details, 'parcelSize3', 'ParcelSize3'),
    port3: details?.port3 ?? null,
    addAld3: details?.addAld3 ?? null,
    port1StartDate: details?.startDate ?? details?.startDate1 ?? null,
    port1EndDate: details?.endDate ?? details?.endDate1 ?? null,
    port2StartDate: details?.startDate2 ?? null,
    port2EndDate: details?.endDate2 ?? null,
    port3StartDate: details?.startDate3 ?? null,
    port3EndDate: details?.endDate3 ?? null,
    cbm: details?.undyed ?? '',
    unitBbl: details?.dyed ?? '',
    dyed: details?.dyed ?? '',
    undyed: details?.undyed ?? '',
    dyed2: details?.dyed2 ?? '',
    undyed2: details?.undyed2 ?? '',
    alpha:
      pickDetailValue(
        details,
        'alphaMitra1',
        'AlphaMitra1',
        'alpha',
        'Alpha',
        'alpha1',
        'Alpha1'
      ) ?? '',
    alphaImprovement:
      details?.alphaImprovement ?? details?.AlphaImprovement ?? null,
    counterAlphaImprovement:
      details?.counterAlphaImprovement ??
      details?.CounterAlphaImprovement ??
      null,
    alphaHps: pickDetailValue(
      details,
      'alphaHps',
      'AlphaHps',
      'hpsAlpha',
      'HpsAlpha'
    ),
    alphaDyedHps: pickDetailValue(
      details,
      'alphaDyedHps',
      'AlphaDyedHps',
      'hpsAlphaDyed',
      'HpsAlphaDyed',
      'alphaHpsDyed'
    ),
    alphaUndyedHps: pickDetailValue(
      details,
      'alphaUndyedHps',
      'AlphaUndyedHps',
      'hpsAlphaUndyed',
      'HpsAlphaUndyed',
      'alphaHpsUndyed'
    ),
    matchingHps: pickDetailValue(
      details,
      'matchingHps',
      'MatchingHps',
      'hpsMatching',
      'HpsMatching',
      'matchingHpsStatus'
    ),
    improvementDyed: pickDetailValue(
      details,
      'improvementDyed',
      'ImprovementDyed'
    ),
    improvementUndyed: pickDetailValue(
      details,
      'improvementUndyed',
      'ImprovementUndyed'
    ),
    improvementAlpha: pickDetailValue(
      details,
      'improvementAlpha',
      'ImprovementAlpha'
    ),
    improvementDyed2: pickDetailValue(
      details,
      'improvementDyed2',
      'ImprovementDyed2'
    ),
    improvementUndyed2: pickDetailValue(
      details,
      'improvementUndyed2',
      'ImprovementUndyed2'
    ),
    improvementAlpha2: pickDetailValue(
      details,
      'improvementAlpha2',
      'ImprovementAlpha2'
    ),
    improvementQuantityLocation1: pickDetailValue(
      details,
      'improvementQuantityLocation1',
      'ImprovementQuantityLocation1'
    ),
    improvementQuantityLocation2: pickDetailValue(
      details,
      'improvementQuantityLocation2',
      'ImprovementQuantityLocation2'
    ),
    improvementQuantityLocation3: pickDetailValue(
      details,
      'improvementQuantityLocation3',
      'ImprovementQuantityLocation3'
    ),
    parcelSizeLabel: pickDetailValue(
      details,
      'parcelSizeLabel',
      'ParcelSizeLabel'
    ),
    cargoRatio: pickDetailValue(
      details,
      'cargoRatio',
      'CargoRatio',
      'ratioLpgId',
      'RatioLpgId'
    ),
    cargoRatioLabel: pickDetailValue(
      details,
      'cargoRatioLabel',
      'CargoRatioLabel',
      'ratioName',
      'RatioName'
    ),
    ratioLpg:
      details?.ratioLpg?.ratioName ??
      details?.ratioLpg?.name ??
      details?.ratioLpg ??
      null,
    counterIncoterm: details?.counterIncoterm ?? details?.incoterm2 ?? null,
    counterRoute: details?.counterRoute ?? details?.route2 ?? null,
    counterLoadingPort:
      details?.counterLoadingPort ??
      details?.counterPort1 ??
      details?.loadingPort2 ??
      null,
    counterParcelSize:
      pickDetailValue(
        details,
        'counterParcelSize',
        'parcelSizeCounter',
        'CounterParcelSize',
        'ParcelSizeCounter'
      ) ?? null,
    counterStartDate:
      details?.counterStartDate ?? details?.startDateCounter ?? null,
    counterEndDate: details?.counterEndDate ?? details?.endDateCounter ?? null,
    counterAddAld: details?.counterAddAld ?? details?.addAldCounter ?? null,
    counterDeliveryBasis:
      pickDetailValue(
        details,
        'counterDeliveryBasis',
        'CounterDeliveryBasis',
        'deliveryBasisCounter',
        'DeliveryBasisCounter'
      ) ?? null,
    counterPort2:
      details?.counterPort2 ?? details?.port2Counter ?? details?.port22 ?? null,
    counterParcelSize2:
      pickDetailValue(
        details,
        'counterParcelSize2',
        'CounterParcelSize2',
        'parcelSize2Counter'
      ) ?? null,
    counterStartDate2:
      details?.counterStartDate2 ?? details?.startDate2Counter ?? null,
    counterEndDate2:
      details?.counterEndDate2 ?? details?.endDate2Counter ?? null,
    counterAddAld2: details?.counterAddAld2 ?? details?.addAld2Counter ?? null,
    counterPort3:
      details?.counterPort3 ?? details?.port3Counter ?? details?.port32 ?? null,
    counterParcelSize3:
      pickDetailValue(
        details,
        'counterParcelSize3',
        'CounterParcelSize3',
        'parcelSize3Counter'
      ) ?? null,
    counterStartDate3:
      details?.counterStartDate3 ?? details?.startDate3Counter ?? null,
    counterEndDate3:
      details?.counterEndDate3 ?? details?.endDate3Counter ?? null,
    counterAddAld3: details?.counterAddAld3 ?? details?.addAld3Counter ?? null,
    counterDyed: details?.dyed2 ?? details?.counterDyed ?? '',
    counterUndyed: details?.undyed2 ?? details?.counterUndyed ?? '',
    counterAlpha:
      pickDetailValue(
        details,
        'alphaMitra2',
        'AlphaMitra2',
        'counterAlpha',
        'CounterAlpha',
        'alpha2',
        'Alpha2'
      ) ?? '',
    alpha2:
      pickDetailValue(
        details,
        'alphaMitra2',
        'AlphaMitra2',
        'alpha2',
        'Alpha2'
      ) ?? '',
    counterOperationalTolerance:
      details?.counterOperationalTolerance ??
      details?.operationalTolerance2 ??
      null,
    isCapable:
      details?.isCapable ?? details?.capable ?? details?.isIsCapable ?? null,
    capable:
      details?.isCapable ?? details?.capable ?? details?.isIsCapable ?? null,
    isImprovement: details?.isImprovement ?? details?.IsImprovement ?? false,
    closingDateImprovement:
      details?.closingDateImprovement ??
      details?.ClosingDateImprovement ??
      details?.dateImprovement ??
      details?.DateImprovement ??
      null,
    counterIsImprovement:
      details?.counterIsImprovement ?? details?.CounterIsImprovement ?? false,
    counterClosingDateImprovement:
      details?.counterClosingDateImprovement ??
      details?.CounterClosingDateImprovement ??
      details?.dateImprovement ??
      details?.DateImprovement ??
      null,
  };
};

export const formatIncotermRoute = (incoterm, route) => {
  if (incoterm && route) return `${incoterm} - ${route}`;
  return incoterm || route || '-';
};

export const formatPortLocation = value => {
  if (value === null || value === undefined) return '-';
  const text = String(value).trim();
  return text || '-';
};

export const formatParcelSize = (value, unitLabel = 'MB') => {
  const unit = unitLabel || 'MB';
  if (value === null || value === undefined) return `- ${unit}`;
  const numericValue = Number(value);
  const text = Number.isFinite(numericValue)
    ? String(numericValue)
    : String(value).trim();
  if (!text || text === '-') return `- ${unit}`;
  const unitPattern = new RegExp(`\\b${unit}\\b`, 'i');
  if (unitPattern.test(text)) return text;
  if (/\b(MB|MT)\b/i.test(text)) return text;
  return `${text} ${unit}`;
};

export const formatPortDateRange = (startDate, endDate, fallbackDate) => {
  const start = convertToDisplayDateFormatddmmmyyyy(startDate);
  const end = convertToDisplayDateFormatddmmmyyyy(endDate);

  if (start && end) return `${start} - ${end}`;
  if (start) return start;
  if (end) return end;

  if (fallbackDate === null || fallbackDate === undefined) return '-';
  const fallback = String(fallbackDate).trim();
  return fallback || '-';
};

export const formatAlphaPrice = (value, unitSuffix = 'USD/bbl') => {
  if (value === null || value === undefined || value === '') return '-';
  const text = String(value).trim();
  if (!text || text === '-') return '-';
  if (/USD|BBL|MT/i.test(text)) return text;
  return `${text} ${unitSuffix}`;
};

/** First non-empty pricing value ('' does not block fallback; negatives allowed). */
export const coalesceAlphaPrice = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined) continue;
    const text = String(value).trim();
    if (!text || text === '-' || text === 'null' || text === 'undefined') {
      continue;
    }
    return value;
  }
  return '';
};

export const isAlphaFilled = value => {
  if (value === null || value === undefined) return false;
  const text = String(value).trim();
  if (!text || text === '-' || text === 'null' || text === 'undefined') {
    return false;
  }
  const numeric = Number(String(text).replace(/[^\d.-]/g, ''));
  if (Number.isFinite(numeric)) return numeric !== 0;
  return true;
};

export const resolveRowCapable = (row, useAlphaField = false) => {
  const capable = row?.isCapable ?? row?.capable;
  if (capable === true || capable === 1 || capable === '1') return true;
  if (capable === false || capable === 0 || capable === '0') return false;
  if (useAlphaField) return isAlphaFilled(row?.alpha);
  return (
    isAlphaFilled(row?.dyed ?? row?.unitBbl) ||
    isAlphaFilled(row?.undyed ?? row?.cbm)
  );
};

export const fetchProductTypePricingUnit = async (productTypeId, token) => {
  if (!productTypeId || !token) return null;
  const response = await fetch(`${api.API_URL}/product-type/${productTypeId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  });
  if (!response.ok) return null;
  const data = await response.json();
  return (
    data?.pricingUnit ??
    data?.PricingUnit ??
    data?.data?.pricingUnit ??
    data?.data?.PricingUnit ??
    null
  );
};
